import { Box, SimpleGrid, Text } from '@chakra-ui/react';

export default function ParahubInformation({ parahubInfo }) {
    return (
        <Box>
            <SimpleGrid columns={4} spacing={'24px'}>
                {parahubInfo.map(({ label, value }) => (
                    <Box key={label} mb="8px">
                        <Text fontSize="14px" fontWeight={700} mb={'4px'}>
                            {label}
                        </Text>
                        <Text fontSize="14px">{value}</Text>
                    </Box>
                ))}
            </SimpleGrid>
        </Box>
    );
}
